module.exports = __webpack_public_path__ + "img/sec-circle1.0841a58.png";